import { render, staticRenderFns } from "./CreateMovements.vue?vue&type=template&id=c071e1b0&"
import script from "./CreateMovements.vue?vue&type=script&lang=js&"
export * from "./CreateMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports